import { ExampleRegistry } from './ExampleRegistry';
import { CategoryInfo } from '../types/example.types';

/**
 * Глобальный инстанс ExampleRegistry с предзагруженными базовыми категориями
 */
export const registry = new ExampleRegistry();

// Предзагружаем базовые категории для примеров
const basicCategories: CategoryInfo[] = [
  {
    id: 'basic',
    label: '📁 Basic Examples',
    description: 'Simple dialog examples to get started',
    order: 1,
    color: '#2196f3' // blue
  },
  {
    id: 'forms',
    label: '📝 Forms & Validation',
    description: 'Form components with validation examples',
    order: 2,
    color: '#4caf50' // green
  },
  {
    id: 'advanced',
    label: '🚀 Advanced',
    description: 'Complex examples with multiple features',
    order: 3,
    color: '#ff9800' // orange
  },
  {
    id: 'patterns',
    label: '🎯 Common Patterns',
    description: 'Reusable patterns and compositions',
    order: 4,
    color: '#9c27b0' // purple
  },
  {
    id: 'hooks',
    label: '🔄 Hooks & Utils',
    description: 'Custom hooks and utility examples',
    order: 5,
    color: '#f44336' // red
  }
];

// Регистрируем все базовые категории
basicCategories.forEach(category => {
  registry.registerCategory(category);
});

// Вспомогательная функция для быстрого получения статистики
export function getRegistryStats() {
  const stats = registry.getStats();

  console.group('📊 PlaybookComponent Registry Stats');
  console.log(`Total Examples: ${stats.totalExamples}`);
  console.log(`Total Categories: ${stats.totalCategories}`);
  console.log('Examples by Complexity:', stats.examplesByComplexity);
  console.log('Categories with Examples:');
  stats.categoriesWithCounts.forEach(({ category, count }) => {
    console.log(`  ${category.label}: ${count} examples`);
  });
  console.groupEnd();

  return stats;
}

// Вспомогательная функция для разработки - быстрое добавление тестовых примеров
export function registerMockExamples() {
  // Простой mock пример для тестирования
  const mockExample = {
    id: 'simple-dialog-mock',
    title: 'Simple Dialog (Mock)',
    description: 'A mock example for testing the registry system',
    component: () => null, // Заглушка компонента
    sourceCode: '// Mock source code\nconst MockComponent = () => <div>Mock</div>;',
    tags: ['mock', 'test', 'simple'],
    category: 'basic',
    complexity: 'basic' as const,
    dependencies: ['BaseDialog'],
    meta: {
      author: 'System',
      createdAt: new Date(),
      version: '1.0.0'
    }
  };

  registry.registerExample(mockExample);

  console.log('🎭 Mock example registered:', mockExample.id);
  return mockExample;
}